import ModalOverlay from "./ModalOverlay.vue";
import { pluginify } from "./../../util";

pluginify(ModalOverlay);

export default ModalOverlay;
export { ModalOverlay };
